export type CreateComponentDeploymentRequestsResponse = {
  warningMessage: string[] | null;
};
